import React from 'react';
import agentListStyles from '../../components/agentlist/AgentList.less';
import agentItemStyles from '../../components/agentlistitem/AgentListItem.less';
var RLTTeaser = function RLTTeaser() {
  return /*#__PURE__*/React.createElement("a", {
    href: "/maklervergleich/?cmp_id=10-052022&cmp_name=residential_realtorleadengine&cmp_position=residential_realtorsearch&cmp_creative=rle_teaser_serp",
    className: agentListStyles.agentProfilePageUrlLink,
    "data-testid": "rlt-teaser-link",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: " ".concat(agentItemStyles.agentListItem, " align-center padding-l")
  }, /*#__PURE__*/React.createElement("h2", {
    className: "font-heading-small-regular",
    "data-testid": "rlt-teaser-title"
  }, "Wir finden f\xFCr Sie den passenden Makler aus Ihrer Region"), /*#__PURE__*/React.createElement("ul", {
    "data-testid": "rlt-teaser-list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "margin-top"
  }, ' ', /*#__PURE__*/React.createElement("i", {
    className: "is24-icon-positive-check font-heading-medium-regular"
  }), " 100% kostenlos & unverbindlich"), /*#__PURE__*/React.createElement("li", {
    className: "margin-top"
  }, /*#__PURE__*/React.createElement("i", {
    className: "is24-icon-positive-check font-heading-medium-regular"
  }), " Passende Makler deutschlandweit"), /*#__PURE__*/React.createElement("li", {
    className: "margin-top"
  }, /*#__PURE__*/React.createElement("i", {
    className: "is24-icon-positive-check font-heading-medium-regular"
  }), " Zeit sparen beim Verkauf")), /*#__PURE__*/React.createElement("span", {
    "data-testid": "rlt-teaser-button",
    className: "button margin-top-xl"
  }, "Jetzt Makler finden")));
};
export default RLTTeaser;